{
    "intro_heading": "KIES JOUW TAAL CHOISIS TA LANGUE",
    "intro_button_nl": "Nederlands",
    "intro_button_fr": "Français",

    "question_heading": "Raad jij waar deze foto is genomen?",
    "question_cta": "Ga verder",

    "outro_wrong_title": "Oeps...",
    "outro_wrong_description": "Dat is niet het juiste antwoord.",
    "outro_wrong_retry": "Probeer opnieuw",
    "outro_wrong_showanswer": "Bekijk antwoord",

    "outro_answer_title": "Het juiste antwoord is",
    "outro_answer_description_bxl": "Duitsland: Het Eibsee",
    "outro_answer_description_ant": "Duitsland: De Eichfelsen-rots",
    "outro_answer_description_lie": "Duitsland: Het Jasmund Nationaal Park",
    "outro_answer_description_gnt": "Duitsland: Het Nationaal Park Sächsische Schweiz",
    "outro_answer_retry": "Probeer opnieuw",

    "outro_correct_title": "JUIST!",
    "outro_correct_description": "Deze foto is genomen in:",
    "outro_correct_anwser_bxl": "Duitsland, aan het Eibsee (Beieren, Grainau). Vanaf hier ben je 786 km van de bestemming.",
    "outro_correct_anwser_ant": "Duitsland, bij de Eichfelsen-rots (Baden-Württemberg, Irndorf). Vanaf hier ben je 630km van de bestemming.",
    "outro_correct_anwser_lie": "Duitsland, in het Nationaal Park Jasmund (West-Pommeren-Rügen, Sassnitz). Vanaf hier ben je 873km van de bestemming.",
    "outro_correct_anwser_gnt": "Duitsland, in het Nationaal Park Saksisch Zwitserland (Saksen, Lohmen). Vanaf hier ben je 832km van de bestemming.",
    
    "outro_correct_subtitle": "Scan de QR-code om deel te nemen aan de wedstrijd en een reis naar Duitsland te winnen:"
}